import ENVIROMENTS from '../../Components/Environment/Configuration.json';
import {useState,useEffect, useContext} from 'react';
import React, {Component} from "react";
import {Helmet} from "react-helmet";
import Popular from '../../Components/Profile/Popular.js'
import LikedSongs from '../../Components/Profile/LikedSongs.js'
import Albums from '../../Components/Profile/Albums.js'
import Followers from '../../Components/Profile/Followers.js'
import Following from '../../Components/Profile/Following.js'
import NewestSongs from '../../Components/Profile/NewestSongs.js'
import Button from '@mui/material/Button';
import Engagement from '../../Components/Profile/Engagement.js';
import useFetchFollow from '../../Components/APIs/FollowUser.js';
import useFetch from '../../Components/APIs/FetchUsers.js'; 
import { UserStoreContext } from '../../Components/Contexts/UserStoreContext.js';
import {ViewContext} from '../../Components/Contexts/ViewContext.js';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CircularProgress from '@mui/material/CircularProgress';
import CompleteProfile from '../../Components/Profile/CompleteProfile.js'
import ViewImageModal from '../../Components/viewImageModal.js'
import ShareLink from '../../Components/ShareLink.js'
import Linkify from 'linkify-react';
import NavigationMenuToggle from '../../Components/Navigation/NavigationMenuToggle.js'
import Tooltip from '@mui/material/Tooltip';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {useParams,Link,useNavigate  }  from'react-router-dom';
import IsLoading from '../../Components/isLoading.js';
import { prominent } from 'color.js';
import LogginDialog from '../../Components/Dialogs/LogginDialog.js';
import ConvertNum from '../../Components/ConvertNumbers/useConvertLargeNum.js';
import { GeneralFunctionsContext } from '../../Components/Contexts/GeneralFunctionsContext';

export default function ProfileContainer ({props}) {
    const navigate = useNavigate();
    const {is_logged_in, user_store} = useContext(UserStoreContext)
    const {setViewUserData} = useContext(ViewContext)
     const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    
    const [pagescroll, setPageScroll] = useState(0);
    useEffect(()=>{
        window.scrollTo(0, 0)
        window.onscroll = () => {
            setPageScroll(window.pageYOffset)
        }
    },[])


    const {user_id} = useParams();
    
    const[data,setData] = useState(null)
    const [user_request, set_user_request] = useState(null)
    const {data:_user_fetched_data, isLoading:_user_is_loading, error:_user_fetch_error} = useFetch(user_request)

    useEffect(()=>{
        if(_user_fetched_data){
            setData(_user_fetched_data);
          
        }
    },[_user_fetched_data])


    const send_user_request =()=>{
        set_user_request({
            "user_id":user_id,
            "search_string":"",
            "role":"",
            "sort":"topfollowed",
            "page":"",
        })
    }

    const [showLogIn, setShowLogIn] = useState(false);
    //Follow
    const [follow_request,set_follow_request] = useState(null);
    const {data:_follow_fetched_data, isLoading:_follow_is_loading, error: _follow_error} = useFetchFollow(follow_request)


    useEffect(()=>{
        if(_follow_fetched_data){
            if(_follow_fetched_data.length>0){
                send_user_request()
            }
        }
    },[_follow_fetched_data])

    const follow_user =()=>{
        if(is_logged_in){
            if(data){
                set_follow_request({
                    "user_id": data.results[0].user_id
                })
            }
        }else{
            setShowLogIn(true)
        }
        
    }



    const [isViewingImage,setIsViewingImage] = useState(false);
    const[isMenuOpened,setisMenuOpened] = useState(false)


    const[BGColor,setBGColor] = useState(null)
    useEffect(()=>{
        if(data){
            if(data.total_results>0){
                setViewUserData(
                    {
                        "id": data.results[0].user_id,
                        "user_id":data.results[0].user_id,
                        "artist_name": data.results[0].artist_name,
                        "img_url": data.results[0].user_avatar.length>2?"/geniuxmusic/api/media/avatars/smaller/?file_name="+data.results[0].user_avatar:"",
                        "platform": "geniuxmusic"
                    }
                );

                

                if(data.results[0].user_avatar.length>2){

                     // Use relative URL to avoid CORS issues during development
                    const imageUrl = "/geniuxmusic/api/media/avatars/smaller/?file_name="+data.results[0].user_avatar;
                    prominent(imageUrl,{format: 'hex',group: 30}).then(colors => {
                        setBGColor(colors[1]) 
                    }).catch(error => {
                        console.error('Error extracting color from image:', error);
                        setBGColor('#181818');
                    })
                }else{
                    setBGColor('#181818') 
                }
            }else{
                setBGColor('#181818') 
            }
        }
    },[data])

    useEffect(()=>{
        window.scrollTo(0, 0)
        setData(null)
        setViewUserData(null)
        send_user_request()
    },[user_id])
    return (
        <>
        {data && data.total_results>0?
            <>
            <Helmet>
                <title>{"Profile: "+data.results[0].artist_name}</title>
                <meta property="og:title" content={"Profile: "+data.results[0].artist_name}/>
                <meta name="title" content={"Profile: "+data.results[0].artist_name}/>
                <meta name="description" content={data.results[0].bio.length>1?data.results[0].bio.length<90? data.results[0].bio:data.results[0].bio.substring(0, 90) + "...":"Check out this profile on Geniux Music."} key="3"/>
                {data.results[0].user_avatar.length>2?
                <meta property="og:image" content={"/geniuxmusic/api/media/avatars/smaller/?file_name="+data.results[0].user_avatar}/>:
                <meta property="og:image" content="/assets/images/geniuxbanner.jpeg"/>
                }
            </Helmet>
            <div className='has-hero-banner'>            
                <div className={offset > 20 ? "navbar active" : "navbar"} style={{
                    '--navbar-after-bg': '#000',
                    '--navbar-before-bg': (offset > 20 ? BGColor : 'transparent')
                }}>
                    <div className="wrapper">
                        <div className="lft">
                            <IconButton className="icon" onClick={()=>navigate(-1)}>
                                <ArrowBackIcon />
                            </IconButton> 
                            <div className="titles">
                                <p>PROFILE</p>
                                {pagescroll> 80 &&(
                                    <>
                                    {data.results[0].artist_name.length<40?
                                        <p>{data.results[0].artist_name}</p>:
                                        <p>{data.results[0].artist_name.substring(0, 40) + "..."}</p> 
                                    }
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="rgt">
                            <NavigationMenuToggle/>
                        </div>  
                    </div>
                </div>
                <div className="mycontainer">
                    <div className="userbanner">
                        {/* {innerWidth>992 &&(
                        <div className="mypath">
                            <div className="wrapper">
                                <div className="lft">
                                {window.history.length>1?
                                    <Button onClick={()=>navigate(-1)}>
                                    <KeyboardBackspaceIcon/>
                                    </Button>  
                                    :
                                    <Button onClick={()=>navigate(-1)} disabled="true">
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                }
                                </div>
                                <div className="rgt">
                                    <p>
                                        <Link to="" className="active">Profile</Link>
                                        {data && (
                                            <Link to="" className="">/ {data.results[0].artist_name}</Link>
                                        )}
                                        
                                    </p>
                                </div>
                            </div>
                        </div>
                        )} */}
                
                        <div className="background" style={{
                            '--before-bg': BGColor
                        }}></div> 
                        <div className='contain'>
                        {innerWidth>992 &&(
                            <div className="usericon desktop">
                                {data.results[0].user_avatar.length>2?
                                    <img className="ppimg" onClick={()=>setIsViewingImage(true)} src={ENVIROMENTS.baseUrl + "/geniuxmusic/api/media/avatars/smaller/?file_name="+data.results[0].user_avatar}/>
                                :
                                    <div className="ppimg">
                                    {data.results[0].artist_name.substring(0, 1)}
                                    </div>
                                }
                            </div>  
                        )}
                        
                            <div className="flexdv">
                                <div className="lft">
                                    <div className="titles01">
                                        <p>{data.results[0].artist_name}</p>
                                        <p>{data.results[0].interest}</p>
                                    </div>
                                    <p className="titles02">
                                        <Linkify>
                                            {data.results[0].bio}
                                        </Linkify>
                                    </p>
                                    
                                    
                                    
                                </div>
                                {innerWidth<992 &&(
                                <div className="rgt">
                                        {data.results[0].user_avatar.length>2?
                                            <img className="ppimg" onClick={()=>setIsViewingImage(true)}src={ENVIROMENTS.baseUrl + "/geniuxmusic/api/media/avatars/smaller/?file_name="+data.results[0].user_avatar}/>
                                        :
                                            <div className="ppimg">
                                            {data.results[0].artist_name.substring(0, 1)}
                                            </div>
                                        }
                                    </div>  
                                )}
                                
                            </div>
                            {innerWidth<992 &&(
                            <div className="icons">
                                    {data.results[0].followed>0? <Button className="active" onClick={()=>follow_user()}>Following {_follow_is_loading && <CircularProgress/>} </Button>:<Button onClick={()=>follow_user()}>Follow {_follow_is_loading && <CircularProgress/>}</Button>

                                    }
                                    {data.results[0].show_email==="true"?
                                        <a href={`mailto:${data.results[0].email}`}><Button><EmailIcon/></Button></a>
                                        :""
                                    }
                                    
                                    <Button onClick={()=>setisMenuOpened(true)}><MoreVertIcon/></Button> 
                                </div>   
                            )}
                            
                        </div>
                        {innerWidth<992 &&(
                        <div className="kpis">
                            <div className="kpi">
                            <Link to={'/profile/browse/'+data.results[0].user_id+'?group=all'}>
                                    <Button>
                                        <p><ConvertNum num = {data.results[0].uploads}/></p>
                                        <p>Uploads</p>  
                                    </Button>
                            </Link>
                                
                            </div>
                            <div className="kpi">
                                <Link to={'/profile/followers/'+data.results[0].user_id}>
                                    <Button >
                                        <p><ConvertNum num = {data.results[0].followers}/></p>
                                        <p>Followers</p>
                                    </Button>
                                </Link>   
                            </div>
                            <div className="kpi">
                            <Link to={'/profile/following/'+data.results[0].user_id}>
                                <Button>
                                    <p><ConvertNum num = {data.results[0].following}/></p>
                                    <p>Following</p>
                                </Button>
                            </Link>  
                            </div>
                        </div>
                        )}
                        {innerWidth>992 &&(
                            <div className="kpisactionbtns">
                                <div className="wrapper">

                            
                                    <div className="lft">
                                        <div className="kpis">
                                            <div className="kpi">
                                            <Tooltip title={data.results[0].uploads + " uploads"} placement="top">
                                                <Link to={'/profile/browse/'+data.results[0].user_id+'?group=all'}>
                                                    <Button>
                                                        <p><ConvertNum num = {data.results[0].uploads}/></p>
                                                        <p>Uploads</p>  
                                                    </Button>
                                                </Link>
                                            </Tooltip>
                                                
                                            </div>
                                            <div className="kpi">
                                            <Tooltip title={data.results[0].followers + " followers"} placement="top">
                                                <Link to={'/profile/followers/'+data.results[0].user_id}>
                                                    <Button>
                                                        <p><ConvertNum num = {data.results[0].followers}/></p>
                                                        <p>Followers</p>
                                                    </Button>
                                                </Link>
                                            </Tooltip>
                                            </div>
                                            <div className="kpi">
                                            <Tooltip title={data.results[0].following + " following"} placement="top">
                                                <Link to={'/profile/following/'+data.results[0].user_id}>
                                                    <Button>
                                                        <p><ConvertNum num = {data.results[0].following}/></p>
                                                        <p>Following</p>
                                                    </Button>
                                                </Link>
                                            </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rgt">
                                        <div className="icons">
                                            {data.results[0].followed>0? <Tooltip title="You are following this user" placement="top"><Button className="active" onClick={()=>follow_user()}>Following {_follow_is_loading && <CircularProgress/>} </Button></Tooltip>:<Tooltip title="Follow this user" placement="top"><Button onClick={()=>follow_user()}>Follow {_follow_is_loading && <CircularProgress/>}</Button></Tooltip>

                                            }
                                            {data.results[0].show_email==="true"?
                                                <Tooltip title={data.results[0].email} placement="top">
                                                    <a href={`mailto:${data.results[0].email}`}><Button><EmailIcon/></Button></a>
                                                </Tooltip>
                                            
                                                :""
                                            }
                                            <Tooltip title="Share this profile" placement="top">
                                                <Button onClick={()=>setisMenuOpened(true)}><MoreVertIcon/></Button> 
                                            </Tooltip>
                                            
                                        </div>   
                                    </div>
                                </div>
                            </div>
                        )}
                    
                    </div>
                
                    {((is_logged_in && user_store.user_id===data.results[0].user_id) &&(data.results[0].user_avatar.length<1 || data.results[0].bio.length<1)) &&(
                        <CompleteProfile data={data.results[0]}/>
                    )}
                    <ViewImageModal isViewingImage={isViewingImage} setIsViewingImage={setIsViewingImage} data={data.results[0]} type="profile"/>

                    {(isMenuOpened && data) &&(
                        <ShareLink setisMenuOpened={setisMenuOpened} data={data.results[0]} type="Profile"/>
                    )}
                    {showLogIn &&(
                        <LogginDialog setShowLogIn={setShowLogIn}/>
                    )}
                    {/* <Banner data={data.results[0].results[0]} />
                */}

                    <div className="wrapper usercontainer">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <section>
                                        <Engagement data={data.results[0]}/>
                                    </section>
                                </div>
                                {data.results[0].songs>0 &&(
                                    <div className="col-12 col-lg-6">
                                        <section>
                                            <Popular user_id={data.results[0].user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                )}
                            </div>
                            {data.results[0].songs>0 &&(
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <section>
                                            <NewestSongs user_id={data.results[0].user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                </div>
                            )}

                            {data.results[0].albums>0 &&(
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <section>
                                            <Albums user_id={data.results[0].user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                </div>
                            )}
                            
                            <div className="row">
                                {data.results[0].followers>0 &&(
                                    <div className="col-12 col-lg-6">
                                        <section>
                                            <Followers user_id={data.results[0].user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                )}
                                {data.results[0].following>0 &&(
                                    <div className="col-12 col-lg-6">
                                        <section>
                                            <Following user_id={data.results[0].user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                )}         
                            </div>
                            {(is_logged_in && user_store.user_id === data.results[0].user_id) && (data.results[0].total_liked_songs > 0) &&(
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <section>
                                            <LikedSongs user_id={user_store.user_id} innerWidth={innerWidth}/>
                                        </section>
                                    </div>
                                </div>
                            )}
                            
                
                    </div>
                </div>
            </div>






        </>
         :data && data.total_results<1?
         <>
            <Helmet>
                <title>User not found</title>
                <meta property="og:title" content="User not found" key="1" />
                <meta name="title" content="User not found" key="2"/>
                <meta name="description" content="Link might be invalid or user has been removed" key="3"/>
                <meta property="og:image" content="/assets/images/geniuxbanner.jpeg" key="4"/>
            </Helmet>
            <div className="navbar">
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=>navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>PROFILE</p>
                            {pagescroll> 80 &&(
                                <p>{user_id}</p>
                            )}
                        </div>
                    </div>
                    <div className="rgt">
                    <NavigationMenuToggle/>
                    </div>  
                </div>
            </div>
            <div className="mycontainer">
                <div className="wrapper">
                    <div className="no_data_msg">
                        <div className="container">
                            <div className="icon">
                                <img src="/assets/images/no_user_found.svg" />
                            </div>
                            <p>User is not found or link might be broken</p> 
                            <Button onClick={()=>send_user_request()}>Retry</Button>
                        </div>
                    </div>
                </div>
            </div>
         
        </>
        :
        _user_fetch_error==="network_err"?
        <>
        <Helmet>
            <title>No Internet</title>
            <meta property="og:title" content="No Internet"/>
            <meta name="title" content="No Internet"/>
            <meta name="description" content="Check your internet connectivity" />
            <meta property="og:image" content="/assets/images/geniuxbanner.jpeg"/>
                
           
        </Helmet>
        <div className="navbar">
            <div className="wrapper">
                <div className="lft">
                    <IconButton className="icon" onClick={()=>navigate(-1)}>
                        <ArrowBackIcon />
                    </IconButton> 
                
                    <div className="titles">
                        <p>PROFILE</p>
                    </div>
                
    
                </div>
                <div className="rgt">
                    <NavigationMenuToggle/>
                </div>
            </div>
        </div>
        <div className="mycontainer">
            {/* {innerWidth>992 &&(
                <div className="mypath">
                    <div className="wrapper ">
                        <div className="lft">
                        {window.history.length>1?
                            <Button onClick={()=>navigate(-1)}>
                            <KeyboardBackspaceIcon/>
                            </Button>  
                            :
                            <Button onClick={()=>navigate(-1)} disabled="true">
                                <KeyboardBackspaceIcon/>
                            </Button>  
                        }
                        </div>
                        <div className="rgt">
                            <p>
                                <Link to="" className="active">PROFILE</Link>
                                <Link to="" className=""></Link>
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
            {(!_user_is_loading) &&(
                <div className='wrapper'>
                    <div className="no_data_msg">
                        <div className="container">
                            <div className="icon">
                                <img src="/assets/images/no_user_found.svg" />
                            </div>
                            <p>Check your internet connectivity</p> 
                            <Button onClick={()=>send_user_request()}>
                                Retry
                            </Button>
                        </div>
                    </div>
                </div> 
            )}  
        </div>
        </>:
        _user_is_loading?
        <>
        <div className="navbar">
            <div className="wrapper">
                <div className="lft">
                    <IconButton className="icon" onClick={()=>navigate(-1)}>
                        <ArrowBackIcon />
                    </IconButton> 
                
                    <div className="titles">
                        <p>PROFILE</p>
                    </div>
                
    
                </div>
                <div className="rgt">
                    <NavigationMenuToggle/>
                </div>
            </div>
        </div>
        <div className="mycontainer">
            {/* {innerWidth>992 &&(
                <div className="mypath">
                    <div className="wrapper ">
                        <div className="lft">
                        {window.history.length>1?
                            <Button onClick={()=>navigate(-1)}>
                            <KeyboardBackspaceIcon/>
                            </Button>  
                            :
                            <Button onClick={()=>navigate(-1)} disabled="true">
                                <KeyboardBackspaceIcon/>
                            </Button>  
                        }
                        </div>
                        <div className="rgt">
                            <p>
                                <Link to="" className="active">Profile</Link>
                                <Link to="" className=""></Link>
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
            
            <div className='wrapper'>
                <IsLoading/>
            </div> 
            
        </div>
        </>:
        <></>
        }
 
        
        </>
    )
}



